import { Navigate, Route, Routes } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { ContentTypesList } from "./pages/ContentTypesList";
import { ContentTypeBuilder } from "./pages/ContentTypeBuilder";
import { EntriesList } from "./pages/EntriesList";
import { EntryEditor } from "./pages/EntryEditor";
import { MediaLibrary } from "./pages/MediaLibrary";
import { InventoryList } from "./pages/InventoryList";
import { ProductEditor } from "./pages/ProductEditor";
import { Integrations } from "./pages/Integrations";
import { SquareIntegration } from "./pages/SquareIntegration";
import { StripeIntegration } from "./pages/StripeIntegration";
import { Subscribers } from "./pages/Subscribers";
import { Sales } from "./pages/Sales";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Navigate to="/login" replace />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/content-types" element={<ContentTypesList />} />
          <Route path="/content-types/new" element={<ContentTypeBuilder />} />
          <Route path="/content-types/:id/edit" element={<ContentTypeBuilder />} />
          <Route path="/content-types/:id/entries" element={<EntriesList />} />
          <Route path="/content-types/:typeId/entries/new" element={<EntryEditor />} />
          <Route path="/entries/:id/edit" element={<EntryEditor />} />
          <Route path="/media" element={<MediaLibrary />} />
          <Route path="/subscribers" element={<Subscribers />} />
          <Route path="/products" element={<InventoryList />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/products/new" element={<ProductEditor />} />
          <Route path="/products/:id/edit" element={<ProductEditor />} />
          <Route path="/settings/integrations" element={<Integrations />} />
          <Route path="/settings/square" element={<SquareIntegration />} />
          <Route path="/settings/stripe" element={<StripeIntegration />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
